import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Редирект со старого адреса на рабочий домен (обход блокировки vercel.app в РФ).
// Только для канонической прод-ссылки — превью-деплои (*-git-*.vercel.app) не трогаем.
if (typeof window !== 'undefined' && window.location.hostname === 'tabel-mr.vercel.app') {
  window.location.replace('https://fieldhubrus.ru' + window.location.pathname + window.location.search + window.location.hash);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
